import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.reduce.js";
import moment from 'moment';
import { validateIdCardNo } from '@/utils/validate';
import { typeMapObj, REPLACE, MINPREMIUM } from './util.js';
export default {
  props: {
    replacePersonnelVisible: {
      type: Boolean,
      default: false
    },
    professionInfo: {
      type: Array,
      default: () => []
    },
    replaceItem: {
      type: Object,
      default: () => {}
    },
    effectiveDate: {
      type: String,
      default: ''
    },
    policyInfo: {
      type: Object,
      default: () => {}
    },
    isEditReplace: {
      type: Boolean,
      default: false
    },
    policyPurpose: {
      type: String,
      default: 'other'
    },
    insurancePlan: {
      type: Array,
      default: () => {}
    },
    occupationTypeOptions: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      form: {},
      form1: {},
      identificationTypeData: [{
        label: '身份证',
        value: 'IDCARD'
      }],
      typeMapObj
    };
  },
  watch: {
    replacePersonnelVisible: {
      handler(val) {
        if (val) {
          this.form = JSON.parse(JSON.stringify(this.replaceItem.reduce));
          this.form1 = JSON.parse(JSON.stringify(this.replaceItem.increase));
        }
      },
      immediate: true
    }
  },
  computed: {
    rules() {
      return {
        insurancePlanCode: [{
          required: true,
          message: '请选择保险方案',
          trigger: 'blur'
        }],
        dispatchCompany: [{
          required: true,
          trigger: 'blur',
          message: '劳动合同单位（共同被保险人）',
          transform: value => {
            return (value === null || value === void 0 ? void 0 : value.trim()) || '';
          }
        }],
        contractCompany: [{
          required: true,
          trigger: 'blur',
          message: '请输入劳动合同单位（合同主体）',
          transform: value => {
            return (value === null || value === void 0 ? void 0 : value.trim()) || '';
          }
        }],
        jobNumber: [{
          required: true,
          message: this.$t('请选择') + this.$t('工种'),
          trigger: 'blur'
        }],
        occupationType: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('工种类别'),
          transform: value => {
            return (value === null || value === void 0 ? void 0 : value.trim()) || '';
          }
        }],
        type: [{
          required: true,
          message: this.$t('请选择') + this.$t('类型'),
          trigger: 'blur'
        }],
        name: [{
          required: true,
          message: this.$t('请输入') + this.$t('姓名'),
          trigger: 'blur',
          transform: value => {
            return (value === null || value === void 0 ? void 0 : value.trim()) || '';
          }
        }, {
          min: 2,
          max: 15,
          message: this.$t('请输入长度2-15的内容'),
          transform: value => {
            return (value === null || value === void 0 ? void 0 : value.trim()) || '';
          }
        }],
        identificationValue: [{
          required: true,
          message: this.$t('请选择') + this.$t('证件类型'),
          trigger: 'blur'
        }],
        idNumber: [{
          required: true,
          message: this.$t('请输入') + this.$t('证件号码'),
          trigger: 'blur'
        }, {
          validator: this.validateCard,
          trigger: 'blur'
        }],
        endAt: [{
          required: true,
          message: this.$t('请选择') + this.$t('责任止期'),
          trigger: 'blur'
        }],
        startAt: [{
          required: true,
          message: this.$t('请选择') + this.$t('责任起期'),
          trigger: 'blur'
        }],
        premium: [{
          required: true,
          message: this.$t('请输入') + this.$t('保费'),
          trigger: 'blur'
        }],
        remark: [{
          max: 200,
          message: this.$t('请输入长度200以内的内容'),
          trigger: 'blur',
          transform: value => {
            return (value === null || value === void 0 ? void 0 : value.trim()) || '';
          }
        }]
      };
    }
  },
  methods: {
    validateCard(rule, idcard, callback) {
      let idCardTrim = (idcard === null || idcard === void 0 ? void 0 : idcard.trim()) || '';
      if (!validateIdCardNo(idCardTrim) || idcard == '') {
        callback(new Error(this.$t('请输入正确的身份证号')));
      } else {
        callback();
      }
    },
    cancel() {
      this.$emit('update:replacePersonnelVisible', false);
    },
    onSubmit() {
      this.$refs.dataFrom1.validate(valid => {
        if (valid) {
          var _this$form$idNumber, _this$form1$idNumber, _this$professionInfo$, _this$identificationT, _this$form1$name, _this$form1$idNumber2, _this$form1$remark, _this$identificationT2, _this$professionInfo$2;
          let formIdNumber = ((_this$form$idNumber = this.form.idNumber) === null || _this$form$idNumber === void 0 ? void 0 : _this$form$idNumber.trim().toLocaleUpperCase()) || '';
          let form1IdNumber = ((_this$form1$idNumber = this.form1.idNumber) === null || _this$form1$idNumber === void 0 ? void 0 : _this$form1$idNumber.trim().toLocaleUpperCase()) || '';
          if (formIdNumber === form1IdNumber) {
            this.$message.error(this.$t('替换人员证件号相同，请确认'));
            return;
          }
          if (this.replaceItem.price > 0 && this.replaceItem.price < MINPREMIUM) {
            this.$message.error(this.$t('保费金额过小无法计算，请联系平台管理员'));
            return;
          }
          let occupation = (_this$professionInfo$ = this.professionInfo.filter(item => item.jobNumber === this.form1.jobNumber)) === null || _this$professionInfo$ === void 0 || (_this$professionInfo$ = _this$professionInfo$[0]) === null || _this$professionInfo$ === void 0 ? void 0 : _this$professionInfo$.occupation;
          let identificationType = (_this$identificationT = this.identificationTypeData.filter(item => item.value === this.form1.identificationValue)) === null || _this$identificationT === void 0 || (_this$identificationT = _this$identificationT[0]) === null || _this$identificationT === void 0 ? void 0 : _this$identificationT.label;
          let increase = {
            occupation: occupation,
            type: this.form1.type,
            name: ((_this$form1$name = this.form1.name) === null || _this$form1$name === void 0 ? void 0 : _this$form1$name.trim()) || '',
            identificationType: identificationType,
            identificationValue: this.form1.identificationValue,
            jobNumber: this.form1.jobNumber,
            idNumber: ((_this$form1$idNumber2 = this.form1.idNumber) === null || _this$form1$idNumber2 === void 0 ? void 0 : _this$form1$idNumber2.trim().toLocaleUpperCase()) || '',
            endAt: this.replaceItem.endAt,
            startAt: moment(this.effectiveDate).format('YYYY-MM-DD') + ' 00:00:00',
            remark: ((_this$form1$remark = this.form1.remark) === null || _this$form1$remark === void 0 ? void 0 : _this$form1$remark.trim()) || '',
            premium: this.form1.premium
          };
          let reduceIdentifyType = (_this$identificationT2 = this.identificationTypeData.filter(item => item.value === this.form.identificationValue)) === null || _this$identificationT2 === void 0 || (_this$identificationT2 = _this$identificationT2[0]) === null || _this$identificationT2 === void 0 ? void 0 : _this$identificationT2.label;
          let reduceOccupation = (_this$professionInfo$2 = this.professionInfo.filter(item => item.jobNumber === this.form.jobNumber)) === null || _this$professionInfo$2 === void 0 || (_this$professionInfo$2 = _this$professionInfo$2[0]) === null || _this$professionInfo$2 === void 0 ? void 0 : _this$professionInfo$2.occupation;
          let reduce = {
            occupation: reduceOccupation,
            jobNumber: this.form.jobNumber,
            policyId: this.policyInfo.policyId,
            type: this.form.type,
            name: this.form.name,
            identificationType: reduceIdentifyType,
            identificationValue: this.form.identificationValue,
            idNumber: this.form.idNumber,
            endAt: this.form.endAt,
            startAt: this.replaceItem.originStartAt,
            remark: this.form.remark,
            premium: this.form.premium,
            originalEndAt: this.replaceItem.endAt
          };
          let replaceItem = {
            type: REPLACE,
            occupation: increase.occupation,
            name: increase.name,
            identificationType: increase.identificationType,
            idNumber: increase.idNumber,
            endAt: increase.endAt,
            startAt: increase.startAt,
            remark: increase.remark,
            originStartAt: this.replaceItem.originStartAt,
            increase,
            reduce,
            idx: this.replaceItem.idx,
            price: this.replaceItem.price,
            rowKey: this.replaceItem.rowKey
          };
          if (this.policyPurpose === 'groupInsurance') {
            var _this$form$occupation, _this$form$contractCo, _this$form$dispatchCo, _this$insurancePlan$f, _this$form1$occupatio, _this$form1$contractC, _this$form1$dispatchC;
            //爱柚味产品  多的字段
            reduce.occupationType = ((_this$form$occupation = this.form.occupationType) === null || _this$form$occupation === void 0 ? void 0 : _this$form$occupation.trim()) || '';
            reduce.insurancePlanCode = this.form.insurancePlanCode;
            reduce.contractCompany = ((_this$form$contractCo = this.form.contractCompany) === null || _this$form$contractCo === void 0 ? void 0 : _this$form$contractCo.trim()) || '';
            reduce.dispatchCompany = ((_this$form$dispatchCo = this.form.dispatchCompany) === null || _this$form$dispatchCo === void 0 ? void 0 : _this$form$dispatchCo.trim()) || '';
            let insuranceObj = (_this$insurancePlan$f = this.insurancePlan.filter(item => item.mark === this.form1.insurancePlanCode)) === null || _this$insurancePlan$f === void 0 ? void 0 : _this$insurancePlan$f[0];
            reduce.insurancePlanName = (insuranceObj === null || insuranceObj === void 0 ? void 0 : insuranceObj.name) || '';
            increase.occupationType = ((_this$form1$occupatio = this.form1.occupationType) === null || _this$form1$occupatio === void 0 ? void 0 : _this$form1$occupatio.trim()) || '';
            increase.insurancePlanCode = this.form1.insurancePlanCode;
            // let insuranceObj = this.insurancePlan.filter(item => item.mark === this.form1.insurancePlanCode)?.[0];
            increase.insurancePlanName = reduce.insurancePlanName;
            increase.contractCompany = ((_this$form1$contractC = this.form1.contractCompany) === null || _this$form1$contractC === void 0 ? void 0 : _this$form1$contractC.trim()) || '';
            increase.dispatchCompany = ((_this$form1$dispatchC = this.form1.dispatchCompany) === null || _this$form1$dispatchC === void 0 ? void 0 : _this$form1$dispatchC.trim()) || '';
            replaceItem.insurancePlanCode = reduce.insurancePlanCode;
            replaceItem.insurancePlanName = reduce.insurancePlanName;
            replaceItem.occupationType = increase.occupationType;
            replaceItem.contractCompany = increase.contractCompany;
            replaceItem.dispatchCompany = increase.dispatchCompany;
          }
          this.$emit('saveReplace', replaceItem, this.isEditReplace);
        }
      });
    }
  }
};